import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, ZMath, ZTime } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XDiv, XIconButton, XText, XTooltip } from "IZOX/_X";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import { QFCheckBox } from "IZOX/BLOCKS/Libs/QForm/_gears";
import _ from "lodash";
import ClaimUtils from "../_utils/ClaimUtils";
import { HiDownload } from "react-icons/hi";

/**
 * @augments {Component<Props, State>}
 */
class ClaimRowW extends Component {

  static propTypes = {
    claimDoc: PropsType.any,
    onViewDetailPress: PropsType.func,
    onDownload: PropsType.func,
    onUpload: PropsType.func,
    checked: PropsType.bool,
    onCheck: PropsType.func,
    isAgent: PropsType.bool
  }

  static defaultProps = {
    claimDoc: {},
    onViewDetailPress: null,
    onDownload: null,
    onUpload: null,
    checked: false,
    onCheck: null,
    isAgent: false
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ClaimRowW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  renderVertBox(label, value, style, containerStyle){
    return (
      <VStack width={100} HAlign="[" mH={5} style={containerStyle}>
        <HStack HAlign="[" fitWidthToContent>
          <XText color={ColorX.CSS("Gray4")} fullWidth
            fontSize={12}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <HStack HAlign="[" fitWidthToContent>
          <XText color={ColorX.CSS("Stone")} fontSize={13}
            style={style} fullWidth>
            {LocaleX.Parse(value)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  render(){
    let {claimDoc, onViewDetailPress, checked, onCheck, isDashboard, onDownload, isAgent} = this.props;  
    let {_id, dcDoc, policyDoc, maidDoc, paid, clientDoc,
      createdAt, claimDate, status, claimIncurred, payAt} = claimDoc ?? {};
    let {policyDuration, packageDoc, startAt, endAt} = policyDoc ?? {};
    let _status = ClaimUtils.GetStatus(status);

    let planStr = `${policyDuration} ${policyDuration === 1 ? "year" : "years"}${_.isEmpty(packageDoc?.shortName) ? "" : ` + ${packageDoc?.shortName}`}`;

    return (
      <VStack fullWidth>
        <HStack bgColor={ColorX.CSS(_status.color)} 
          spacing={10} HAlign="[" pV={10} pH={15}>
          <HStack spacing={5} HAlign="[">
            {onCheck &&
              <QFCheckBox name="checked" _onChange={onCheck} formValue={{checked}}/>}
            <XText color={ColorX.CSS("pureWhite")} bold>
              {LocaleX.Parse({
                EN: "Claim no.",
                TC: "索償編號"
              })}
            </XText>
            <XText color={ColorX.CSS("pureWhite")} bold>
              {_id}
            </XText>
          </HStack>
          <Spacer/>
          {onDownload &&
            <XTooltip tooltip={LocaleX.Parse({
              EN: "Download",
              TC: "下載"
            })}>
              <XIconButton onPress={onDownload} padding={5}
                bgColor={ColorX.CSS("ActiveBg")}>
                <HiDownload color={ColorX.CSS("Active")}/>
              </XIconButton>
            </XTooltip>}
        </HStack>
        <HStack bgColor={ColorX.CSS("pureWhite")} pH={20} pV={10}
          justifyContent="space-between">
          {this.renderVertBox({
            EN: "Policy No.",
            TC: "保單編號"
          }, policyDoc.policyNo)}
          {this.renderVertBox({
            EN: "Plan",
            TC: "計劃"
          }, planStr)}
          {this.renderVertBox({ 
            EN: "Date of consultation", 
            TC: "諮詢日期" 
          }, createdAt ? ZTime.Moment(claimDate).format("DD/MM/YYYY") : "----")}
          {this.renderVertBox({
              EN: "Applied date",
              TC: "申請日期"
            }, createdAt ? ZTime.Moment(createdAt).format("DD/MM/YYYY") : "----")}
          <HStack fitWidthToContent>
            {this.renderVertBox({
              EN: "Effective date",
              TC: "生效日期"
            }, startAt ? ZTime.Moment(startAt).format("DD/MM/YYYY") : "----")}
            <VStack width={16} VAlign="_">
              <XDiv mT={22}>
                <MdOutlineArrowRightAlt color={ColorX.CSS("Axit")}/>
              </XDiv>
            </VStack>
            {this.renderVertBox({
              EN: "Expired date",
              TC: "失效日期"
            }, endAt ? ZTime.Moment(endAt).format("DD/MM/YYYY") : "----")}
          </HStack>
          <Spacer/>
          <VStack fitWidthToContent HAlign="]">
            <XDiv bgColor={_status.bgColor} pH={8} width={92}>
              <XText color={_status.color} textAlign="|" fontSize={13}>
                {LocaleX.Parse(_status.label)}
              </XText>
            </XDiv>
            <XButton notInjectColor onPress={onViewDetailPress} padding={0} pV={2}>
              <HStack>
                <XText fontSize={12} color={ColorX.CSS("Axit")} style={{textDecoration: "underline"}}>
                  {LocaleX.Parse(
                    isDashboard ? 
                    {
                      EN: "Receipts",
                      TC: "收據"
                    } : {
                      EN: "View Details",
                      TC: "顯示詳細資料"
                    })}
                </XText>
              </HStack>
            </XButton>
          </VStack>
        </HStack>
        <HStack bgColor={ColorX.CSS("pureWhite")} pH={20} pB={10}
          justifyContent="space-between">
          {this.renderVertBox({
            EN: "Policy Holder",
            TC: "保單持有人"
          }, clientDoc?.meta?.fullName ?? dcDoc?.meta?.fullName)}
          {this.renderVertBox({
            EN: "Insured Person",
            TC: "被保險人"
          }, maidDoc?.fullName)}
          {this.renderVertBox({
            EN: "Incurred Amount",
            TC: "索償金額"
          }, `HKD $${ZMath.NumberWithCommas(claimIncurred)}`)}
          {!isAgent && this.renderVertBox({
            EN: "Paid Amount",
            TC: "已付金額"
          }, paid ? `HKD $${ZMath.NumberWithCommas(paid)}` : "---")}
          {this.renderVertBox({
            EN: "Payment date",
            TC: "付款日期"
          }, payAt ? ZTime.Moment(payAt).format("DD/MM/YYYY") : "----")}
          <Spacer/>
        </HStack>
      </VStack>
    );
  }

}

export default observer(ClaimRowW);
